import { render, staticRenderFns } from "./ProductInformation.vue?vue&type=template&id=3650d610&scoped=true&"
import script from "./ProductInformation.vue?vue&type=script&lang=js&"
export * from "./ProductInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProductInformation.vue?vue&type=style&index=0&id=3650d610&prod&lang=scss&"
import style1 from "./ProductInformation.vue?vue&type=style&index=1&id=3650d610&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3650d610",
  null
  
)

export default component.exports